/**
 * The service worker's response cache, named once so the worker and the app agree.
 *
 * They must: the worker fills this bucket and only the app knows when to empty it. A
 * literal in each place drifts the moment the version is bumped, and the failure is
 * silent — sign-out would clear a cache nothing writes to.
 */
export const API_CACHE = 'nbh-api-v1';

/**
 * Empties the API response cache.
 *
 * Called on sign-out, because the bucket is origin-scoped rather than user-scoped and
 * these are shared phones. `NetworkFirst` caches every `/api/` GET, which includes
 * `/api/attachments/:id` — so without this, photos fetched by one signed-in user stay
 * retrievable by whoever picks the handset up next, and no amount of server-side
 * authorization reaches a copy already on the device.
 *
 * Best-effort and never throws: the Cache API is absent in insecure contexts and in the
 * test environment, and a failure to tidy up must not leave the user signed in.
 */
export async function clearApiCache(): Promise<void> {
  try {
    if (typeof caches === 'undefined') return;
    await caches.delete(API_CACHE);
  } catch {
    // Nothing useful to do or say: the session is being torn down either way.
  }
}
